import { ViewChild, TemplateRef, Component, NgZone } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import { UserService } from './../../services/user.service';
import { FormService } from '../../services/form.service';

import { RutValidator } from 'ng9-rut';

import { MatDialog, MatDialogRef } from 'node_modules/@angular/material/dialog';

import { RegistroComponent } from './registro/registro.component';
import * as _rut from 'rut-helpers'
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { DomSanitizer } from '@angular/platform-browser';
import { emailValidator } from '../../services/match';

@Component({
    selector: "page-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.css"],
    providers: [UserService, FormService, ClaveUnicaService]
})

export class HomeComponent {

    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalResend') openModalResend: TemplateRef<any>;
    @ViewChild('openResetPass') openResetPass: TemplateRef<any>;
    @ViewChild('mailResp') mailResp: TemplateRef<any>;
    @ViewChild('mailNoResp') mailNoResp: TemplateRef<any>;

    public user;
    public matcher = new FormService();
    public identity;
    public token;
    public url;
    public mail;
    public new;

    constructor(private _userService: UserService, rutValidator: RutValidator,
        private fb: FormBuilder, private dialog: MatDialog, private _router: Router,
        public zone: NgZone, private spinner: NgxSpinnerService, private _claveUnicaService: ClaveUnicaService, private sanitizer: DomSanitizer, private dialogRef: MatDialogRef<HomeComponent>) {
        this.user = this.fb.group({
            rut: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
            password: ['', [Validators.required]]
        })
        this.new = this.fb.group({
            rut: ['', [Validators.required, rutValidator]],
            email: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]],
            repeatEmail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        }, {
            validator: emailValidator.match
        })
        this.mail = '';
    }

    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);


    login(user?) {
        var url = localStorage.getItem("navdomcloud")
        this.spinner.show();
        this._userService.login(_rut.rutClean(this.user.value.rut), this.user.value.password).subscribe(
            response => {

                this.identity = response.user;
                if (!this.identity) {
                    alert("Usuario incorrecto")
                } else {
                    sessionStorage.setItem("identity-domCloud", JSON.stringify(this.identity));
                    if (response.token) {
                        this.token = response.token;
                        if (this.token.length <= 0) {
                            console.error("No se ha generado el token");
                        } else {
                            sessionStorage.setItem("token-domCloud", this.token);
                            sessionStorage.setItem("activeCertificado", "true")
                            this.dialog.closeAll();
                            this.spinner.hide();
                            //console.log(localStorage.getItem("navdomcloud"))
                            this._router.navigate([`/${url}`]);

                        }

                    }                    //Conseguir token;
                }
            },
            error => {
                console.log("error", error)
                alert(error.message);
                this.spinner.hide();
            }
        )
    }

    register() {
        this.dialog.open(RegistroComponent, {
            id: "logindialog"
        })
    }

    claveunica() {
        this.dialogRef.close();
        this.spinner.show();
        this._claveUnicaService.getToken().subscribe(
            response => {
                console.log("/////////////////")
                console.log(response)
                this.spinner.hide();
                this.url = this.sanitizer.bypassSecurityTrustResourceUrl(response.url)
                this.dialog.open(this.openModal);
            },
            error => {
                this.spinner.hide();
                console.log(error)
            }
        )
    }

    openResend() {
        this.dialog.open(this.openModalResend);
    }

    openPass() {
        this.dialog.open(this.openResetPass);

    }

    submitRepeatPass() {
        console.log(this.new)
        var withoutSpaces = (this.new.value.repeatEmail).replace(/\ /g, "");
        console.log(withoutSpaces)
        this._userService.sendMailResetPass(this.new.value.rut, withoutSpaces).subscribe(resp => {

            if (resp.status == 'ok') {
                this.spinner.hide();
                this.dialog.closeAll()
                this.dialog.open(this.mailResp);
            } else {
                this.spinner.hide();
                alert(resp.message);
            }



        })
    }

    resendMail() {
        this.spinner.show();
        this._userService.resendMailActivation(this.mail).subscribe(
            response => {
                if (response.message) {
                    alert("Correo de activación reenviado");
                    this.dialog.closeAll();
                    this.spinner.hide();

                }

            },
            error => {
                let e = JSON.parse(error._body);
                alert(e.message);
                this.spinner.hide();
            }
        )

    }
}